<script>
import service from '@/service';
import _ from 'lodash';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	components: {
		Loading
	},
	props: {
		value: Object,
		title: String,
		kupci: Array,
		userCanEdit: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		value: function () {
			if (this.value == null) {
				this.izbran_kupec = null;
			} else {
				this.kupciSelect_change(this.value);
			}
		}
	},
	methods: {
		selectOld (id) {
			this.izbran_kupec = null;
			if (id) {
				for (let item of this.vsiKupci) {
					if (id === item.id) {
						this.izbran_kupec = item;
						break;
					}
				}
			}
			this.$emit('input', this.izbran_kupec);
		},
		select (id) {
			this.izbran_kupec = null;
			if (id) {
				this.kupciLoading = true;
				service.searchKupecById(id)
					.then(response => {
						this.kupciLoading = false;
						if (response.message === 'success') {
							console.log('response.kupec', response.kupec);
							let kupec = response.kupec;
							if (kupec.is_company) {
								kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
							} else {
								kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
							}
							this.izbran_kupec = kupec;
						} else {
							console.error('Neveljaven odziv strežnika');
							// this.$refs.toastr.e('Neveljaven odziv strežnika');
						}
						this.$emit('input', this.izbran_kupec);
					})
					.catch(error => {
						this.kupciLoading = false;
						this.$emit('input', this.izbran_kupec);
						this.clearNovKupec();
						if (error.response) {
							// Request made and server responded
							// this.$refs.toastr.e('Napaka pri potrditvi hramb!');
							console.error(error);
						} else if (error.request) {
							// The request was made but no response was received
							// this.$refs.toastr.e('Napaka pri potrditvi hramb: strežnik se ni odzval!');
							console.error('The request was made but no response was received:', error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							// this.$refs.toastr.e('Napaka pri pošiljanju zahteve za potrditve hramb na strežnik!');
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
			}
		},
		novKupec_Submit (evt) {
			evt.preventDefault();
			service.addKupec(this.obrazec)
				.then(kupec => {
					if (kupec.is_company) {
						kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
					} else {
						kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
					}
					this.vsiKupci.push(kupec);
					// select new item
					this.izbran_kupec = kupec;
					this.$emit('input', this.izbran_kupec);
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		novKupec_Reset (evt) {
			evt.preventDefault();
			this.clearNovKupec();
		},
		clearNovKupec: function () {
			this.obrazec.id = 0;
			this.obrazec.is_company = false;
			this.obrazec.title = '';
			this.obrazec.contact_name = '';
			this.obrazec.first_name = '';
			this.obrazec.last_name = '';
			this.obrazec.email = '';
			this.obrazec.phone_number = '';
			this.prikazi_obrazec = false;
			this.$nextTick(() => { this.prikazi_obrazec = true });
		},
		loadKupci: function () {
			this.kupci_options = [];
			service.searchKupci('#initialize')
				.then(kupci => {
					for (let kupec of kupci) {
						if (kupec.is_company) {
							kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
						} else {
							kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
						}
					}
					this.kupci_options = kupci;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		kupciSelect_load: _.debounce((loading, search, vm) => {
			if (!vm.kupci_searchEmpty) {
				service.searchKupci(search)
					.then(kupci => {
						for (let kupec of kupci) {
							if (kupec.is_company) {
								kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
							} else {
								kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
							}
						}
						loading(false);
						vm.kupci_searched = kupci;
					})
					.catch(error => {
						loading(false);
						if (error) {
							console.log(error);
						}
					});
			} else {
				loading(false);
			}
		}, 500),
		kupciSelect_change (kupec) {
			if (kupec) {
				this.izbran_kupec = kupec;
				this.obrazec.id = kupec.id;
				this.obrazec.is_company = kupec.is_company;
				this.obrazec.title = kupec.title;
				this.obrazec.contact_name = kupec.contact_name;
				this.obrazec.first_name = kupec.first_name;
				this.obrazec.last_name = kupec.last_name;
				this.obrazec.email = kupec.email;
				this.obrazec.phone_number = kupec.phone_number;
			} else {
				this.izbran_kupec = null;
				this.kupci_searched = null;
				this.clearNovKupec();
			}
			this.$emit('input', this.izbran_kupec);
		},
		kupciSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.kupci_searchEmpty = false;
				loading(true);
				this.kupciSelect_load(loading, search, this);
			} else if (search === '' && this.izbran_kupec == null) {
				this.kupci_searched = null;
				this.kupci_searchEmpty = true;
			}
		}
	},
	data: function () {
		return {
			kupci_searchEmpty: false,
			izbran_kupec: null,
			kupci_options: null,
			kupci_searched: null,
			obrazec: {
				id: 0,
				is_company: false,
				title: '',
				contact_name: '',
				first_name: '',
				last_name: '',
				email: '',
				phone_number: ''
			},
			prikazi_obrazec: true,
			kupciLoading: false
		}
	},
	computed: {
		vsiKupci () {
			if (this.kupci_searched != null) {
				return this.kupci_searched;
			} if (this.kupci) {
				return this.kupci;
			} else {
				if (this.kupci_options == null) {
					this.loadKupci();
				}
				return this.kupci_options;
			}
		}
	},
	created () {
	}
}
</script>
<template>
	<b-card>
		<div slot="header">{{ title }}</div>
		<div v-if="kupciLoading">
			<loading :active.sync="kupciLoading" 
				:is-full-page="false"></loading>
		</div>
		<div v-else>
			<b-row>
				<b-col>
					<b-form-group>
						<v-select ref="kupci"
							v-show="userCanEdit"
							v-model="izbran_kupec"
							:options="vsiKupci"
							label="full_name"
							@input="kupciSelect_change"
							@search="kupciSelect_search"
							placeholder="Izberi kupca ...">
							<template slot="no-options">Kupec ni najden</template>
						</v-select>
					</b-form-group>
				</b-col>
			</b-row>
			<b-form @submit="novKupec_Submit" @reset="novKupec_Reset" v-if="prikazi_obrazec">
				<b-form-radio-group v-if="(izbran_kupec == null)" v-model="obrazec.is_company" class="mb-3" :disabled="(izbran_kupec != null)">
					<b-form-radio :value="false">Fizična oseba</b-form-radio>
					<b-form-radio :value="true">Podjetje</b-form-radio>
				</b-form-radio-group>
				<b-row v-if="obrazec.is_company == true">
					<b-col sm="6">
						<b-form-group>
							<label for="title">Naziv</label>
							<b-form-input id="title"
								type="text"
								v-model="obrazec.title"
								required min="2"
								max="150"
								:disabled="(izbran_kupec != null)"
								placeholder="Naziv podjetja"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col sm="6">
						<b-form-group>
							<label for="contact_name">Kontaktna oseba</label>
							<b-form-input id="contact_name"
								type="text"
								v-model="obrazec.contact_name"
								required
								min="2"
								max="150"
								:disabled="(izbran_kupec != null)"
								placeholder="Ime in priimek"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row v-else>
					<b-col>
						<b-form-group label="Ime:" label-for="kupec_ime">
							<b-form-input id="kupec_ime"
								type="text"
								v-model="obrazec.first_name"
								required
								min="2"
								max="150"
								:disabled="(izbran_kupec != null)"
								placeholder="Ime kupca"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Priimek:" label-for="kupec_priimek">
							<b-form-input id="kupec_priimek"
								type="text"
								v-model="obrazec.last_name"
								required
								min="2"
								max="150"
								:disabled="(izbran_kupec != null)"
								placeholder="Priimek kupca"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-form-group label="Email:" label-for="kupec_email">
					<b-form-input id="kupec_email"
						type="email"
						v-model="obrazec.email"
						required
						:disabled="(izbran_kupec != null)"
						placeholder="Elektronski naslov kupca"></b-form-input>
				</b-form-group>
				<b-row>
					<b-col>
						<b-form-group label="Telefonska številka:" label-for="kupec_telefon">
							<b-form-input id="kupec_telefon"
								type="text"
								v-model="obrazec.phone_number"
								:disabled="(izbran_kupec != null)"
								placeholder="Telefonska številka kupca"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col></b-col>
				</b-row>
				<b-row v-if="(izbran_kupec == null)">
					<b-col>
						<b-button type="submit" variant="primary" class="mr-2">Dodaj</b-button>
						<b-button type="reset" variant="danger" class="mr-2">Počisti</b-button>
					</b-col>
				</b-row>
			</b-form>
		</div>
	</b-card>
</template>
<style>
.dropdown-toggle::after {
	border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/PickKupecInline.vue